import React from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

// Small info icon with a hover/tap tooltip. Use it next to metric titles,
// section headers or card titles to explain what a number or panel means.
// Renders nothing when no title is supplied, so it is safe to leave optional.
export default function InfoHint({ title, style, iconStyle }) {
  if (!title) return null;
  return (
    <Tooltip title={title} trigger={["hover", "focus"]}>
      <InfoCircleOutlined
        tabIndex={0}
        role="img"
        aria-label="More info"
        onClick={(e) => e.stopPropagation()}
        style={{
          color: "#8c8c8c",
          fontSize: 13,
          marginLeft: 6,
          cursor: "help",
          verticalAlign: "middle",
          ...iconStyle,
          ...style,
        }}
      />
    </Tooltip>
  );
}
